import { render } from "./Landing.vue?vue&type=template&id=bb8cae34&scoped=true"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"

import "./Landing.vue?vue&type=style&index=0&id=bb8cae34&lang=scss"
import "./Landing.vue?vue&type=style&index=1&id=bb8cae34&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb8cae34"]])

export default __exports__